module.exports = __webpack_public_path__ + "img/undraw-alert.dc8be297.svg";